import React from 'react';

import menuItem from './menu_item';

type Props = {
    to: string;
    content: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    'data-testid'?: string;
}
export const MenuItemExternalLinkImpl: React.FC<Props> = ({to, content, onClick, 'data-testid': dataTestId}: Props) => (
    <a
        data-testid={dataTestId}
        target='_blank'
        rel='noopener noreferrer'
        href={to}
        onClick={onClick}
    >
        {content}
    </a>
);

const MenuItemExternalLink = menuItem(MenuItemExternalLinkImpl);
MenuItemExternalLink.displayName = 'MenuItemExternalLink';
export default MenuItemExternalLink;
